import React from 'react';
import styles from './styles';
import { useIntl } from 'react-intl';
import { View, TouchableOpacity } from 'react-native';
import { Typography } from '@hmsexp/component-library';

const DismissButton = (props) => {
  const intl = useIntl();
  const { onRequestClose } = props;
  return (
    <View style={styles.dismissButton}>
      <TouchableOpacity onPress={onRequestClose}>
        <Typography
          color='white'
          variant='subtitle2'
          fontWeightType='regular'
        >
          {intl.formatMessage({ id: 'POPOVER_DISMISS' })}
        </Typography>
      </TouchableOpacity>
    </View>
  );
};

export default DismissButton;
